"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _styles = _interopRequireDefault(require("../styles"));
var styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },
  row: {
    flexDirection: 'row'
  }
};

/**
 * Wraps controls such as Checkbox and Switch, with compact and changeable layout.
 */
exports.styles = styles;
var FormGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_material.FormGroup, (0, _extends2.default)({}, props, {
    ref: ref
  }));
});
FormGroup.muiName = 'FormGroup';
FormGroup.displayName = 'FormGroup';
FormGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * Display group of elements in a compact row.
   */
  row: _propTypes.default.bool,
  /**
  * The system prop that allows defining system overrides as well as additional CSS styles.
  */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
FormGroup.defaultProps = {
  row: false
};
var _default = (0, _styles.default)(styles)(FormGroup);
exports.default = _default;